<template>
  <div class="home">
        <p class="title">填写注册信息</p>
        <hel ref="child" :msg=item v-for="(item, index) in datas" :key="index"></hel>
        <van-button @click="subMit()" type="primary" size="large" class="submitBtn">完成注册</van-button>
        <!-- <van-button @click="backBtn()" type="default" size="large" class="backBtn">返 回</van-button> -->
  </div>
</template>

<script>
import hel from '@/components/HelloWorld.vue';
import {submit, creator} from '@/api/login/login.js'
import { mapGetters, mapMutations } from 'vuex';
import {getSchool, getSchoolItem, setToken, setInfo} from '@/utils/auth.js';
export default {
      components:{
        hel
      },
      data(){
        return {
          datas:[],
          params:[],
          mynewopti:''
        };
      },
      created(){
        this.getCreator();
      },
      methods:{
        /**
         * 获取动态表单数据
         * @method getCreator
         */
        getCreator(){
          let formData = new FormData();
          // JSON.parse(getSchool()).project_id
          formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id}));
          creator(formData).then(res=> {
            this.datas = res.data;

          }).catch(error => {

          })
        },
        /**
         * 表单提交方法
         * @method subMit
         */
        subMit () {
          this.params = [];
          this.$refs.child.forEach(item=>{
            this.params.push({template_field_id: item.msg.template_field_id,value:item.newValue})
          })
          let formData = new FormData();
          formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id, 'campus':getSchoolItem(), 'params': this.params}));
          submit(formData).then(res => {
            if(res.code == 0){
              setToken(res.data.token)
              setInfo(JSON.stringify(res.data))
              this.$toast.success('注册成功');
              this.$router.push({path:"/", query:{code: this.$route.query.code}});

            }else {
              this.$toast.fail(res.msg);
            }

          })
        },
        /**
         * 返回btn方法
         * @method backBtn
         */
        backBtn(){
          this.$router.push({path:'/login', query:{code: this.$route.query.code}})
        }
      },
      computed: {
        ...mapGetters([
          'schoolItem',
          'school'
        ]),
      }
  }
</script>
<style scoped lang="scss">
  .title{
    width: 100%;
    height: 50px;
    background-color: #fff;
    font-size: 18px;
    line-height: 50px;
    text-align: center;
  }
  .submitBtn{
    margin-top: 20px;
  }
  .backBtn{
    margin: 10px 0 30px 0 ;
  }
</style>
